<template>
    <div v-if="user" class="menu-item"><div style="display: none !important;"><svg><symbols><symbol id="sprite-icon-user"><path d="M8 9.716a4.063 4.063 0 0 0 4.308-4.358C12.308 2.4 11.916 0 8 0S3.693 2.4 3.693 5.358A4.062 4.062 0 0 0 8 9.716zm8 6.495c-.219-1.395-.672-3.191-1.58-3.829-.62-.436-2.784-1.615-3.707-2.118l-.016-.009a.3.3 0 0 0-.329.03 3.9 3.9 0 0 1-1.576.776.305.305 0 0 0-.217.192L8 12.789l-.572-1.537a.3.3 0 0 0-.217-.192 3.9 3.9 0 0 1-1.575-.776.3.3 0 0 0-.329-.03c-.913.5-3.1 1.7-3.721 2.125-1.045.718-1.5 3.318-1.584 3.831a.311.311 0 0 0 .014.151C.053 16.47 1.013 19 8 19s7.946-2.53 7.983-2.638a.3.3 0 0 0 .017-.151zm-3.219-.851l-1.367.435-1.368-.435L10 14h3z" fill-rule="evenodd"/></symbol><symbol id="sprite-triangle-down"><path d="M3.5 4L0 0h7z"/></symbol><symbol id="sprite-icon-logout"><path data-name="Forme 14" d="M5.77 10.523a4.534 4.534 0 0 1-.41-9.026 4.249 4.249 0 0 1 3.03.88.684.684 0 0 0 .82.012l.01-.008a.745.745 0 0 0 .02-1.184A5.6 5.6 0 0 0 5.45.009 6.009 6.009 0 0 0 5.77 12a5.62 5.62 0 0 0 3.34-1.094.742.742 0 0 0-.02-1.192l-.01-.009a.681.681 0 0 0-.8 0 4.235 4.235 0 0 1-2.51.822zm10.09-4.987l-2.3-1.684a.361.361 0 0 0-.57.3v.922H7.73a.632.632 0 0 0-.62.64v.013a.632.632 0 0 0 .62.64h5.26v1.006a.362.362 0 0 0 .56.309l2.3-1.553a.382.382 0 0 0 .01-.6z" fill-rule="evenodd"/></symbol></symbols></svg></div>
        <button type="button" class="btn btn-user flex-container align-middle nowrap" :class="{'is-open': dropdownOpened, 'has-active-store': activeStore}" @click.stop="dropdownOpened = !dropdownOpened">
            <svg inline="" width="24" height="20" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 19"><use xlink:href="#sprite-icon-user"></use></svg>
            <span class="flex-container align-middle">
                <template  v-if="user.first_name">{{ user.first_name }}</template>
                <translate v-else>My account</translate>
                <svg inline="" width="7" height="4" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 4"><use xlink:href="#sprite-triangle-down"></use></svg>
            </span>
        </button>
        <div class="dropdown flex-container flex-dir-column no-bullet" v-if="dropdownOpened == true" @click="close" v-click-outside="close">
            <div class="sub-menu sub-menu-secondary text-center" v-if="activeStore">
                <div class="img-wrapper">
                    <img src="@/assets/svg/icon-store.svg" width="55" height="43" />
                </div>
                <div class="store-wrapper" v-if="activeStore">
                    <div class="store-label" v-translate>Connected as</div>
                    <span class="store-value">{{ activeStore.name }}</span>
                    <button type="button" class="btn btn-link" v-if="user.stores.length > 1" @click.stop="debugSelect = true" v-translate>Change</button>
                    <select name="store-switcher" v-model="activeStore" v-if="user.stores.length > 1 && debugSelect" @click.stop @change="dropdownOpened = false">
                        <option :value="store" v-for="store in user.stores" :key="`store-switch-${store.id}`">{{ `${store.number} - ${store.name}` }}</option>
                    </select>
                </div>
                <div class="nav-wrapper" v-if="user.permissions.indexOf('store') > -1 && activeStore">
                    <router-link :to="{ name: localizedRoute('StoreProfile') }" v-translate>My store</router-link>
                    <span class="separator">&bull;</span>
                    <router-link :to="{ name: localizedRoute('EmployeeList') }" v-translate>My employees</router-link>
                </div>
            </div>
            <ul class="sub-menu sub-menu-primary no-bullet">
                <li>
                    <router-link :to="{ name: localizedRoute('Profile') }" v-translate>My Profile</router-link>
                </li>
                <li>
                    <button class="btn" type="button" @click="toggleLanguage" v-translate>Français</button>
                </li>
                <li>
                    <button class="btn btn-logout" type="button" @click="logout">
                        <span v-translate>Logout</span>
                        <svg inline="" width="16" height="12" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 12"><use xlink:href="#sprite-icon-logout"></use></svg>
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions, mapState } = createNamespacedHelpers('bmr');

export default {
    data () {
        return {
            dropdownOpened: false,
            debugSelect: false,
        };
    },
    computed: {
        ...mapState(['user']),
        activeStore : {
            get () {
                return this.$store.state.bmr.activeStore;
            },
            set (value) {
                this.axios.cache.clear();
                this.updateActiveStore(value);
            }
        },
    },
    methods: {
        ...mapActions(['logout', 'toggleLanguage', 'updateActiveStore']),
        close () {
            this.dropdownOpened = false;
            this.debugSelect = false;
        },
    }
};
</script>

<style lang="scss" scoped>
.btn-user {
    position: relative;
    line-height: 22px;
    color: currentColor;
    text-transform: uppercase;
    height: 100%;
    svg {
        display: block;
        fill: currentColor;
        margin: 0 3px;
    }
    &.is-open {
        &::before {
            content: '';
            display: block;
            position: absolute;
            left: 50%;
            top: 110%;
            width: 20px;
            height: 20px;
            transform: rotate(45deg);
            background-color: $c-atelier;
            z-index: 5;
        }
        &.has-active-store {
            &::before {
                background-color: $white;
            }
        }
    }
}
.dropdown {
    font-family: $font-body;
    font-weight: 600;
    position: absolute;
    margin: 0;
    right: 0;
    background: $white;
    margin-top: 5px;
    z-index: 3;
    width: 250px;
    text-transform: none;
    border-radius: 4px;
    box-shadow: 0px 0px 14px 3px transparentize($black, 0.92);
    select {
        margin-top: 10px;
    }
}
.sub-menu {
    @include rem-typo(12px);
    color: $black;
    padding: 30px 12px;
    border-radius: 0 0 4px 4px;
}
.sub-menu-primary {
    @include rem-typo(13px);
    padding: 20px 30px;
    color: $white;
    background-color: $c-atelier;
    li {
        padding-bottom: 12px;
        margin-bottom: 12px;
        border-bottom: 1px solid $c-atelier-dark;
        &:last-child {
            border: 0;
            padding-bottom: 0;
            margin-bottom: 0;
        }
    }
    a,
    button {
        display: block;
        color: $white;
        text-decoration: none;
        font-weight: 600;
        border-radius: 0;
        min-width: 100%;
        text-align: left;
    }
    svg {
        fill: $white;
    }
}
.img-wrapper,
.store-wrapper,
.nav-wrapper {
    margin-bottom: 12px;
    &:last-child {
        margin-bottom: 0;
    }
}
.btn-logout {
    svg {
        vertical-align: bottom;
    }
}
.store-label {
    font-weight: 700;
}
.store-value {
    color: $c-grey;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/UserMenu.vue